if (!customElements.get('fg-product-features-block')) {
    customElements.define(
      'fg-product-features-block',
      class FGProductFeaturesBlock extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
            subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
                this.onVariantChange(e.data);
            });
        }

        onVariantChange(data) {
            // Update the product features block using section rendering
            fetch(`${this.dataset.url}?variant=${data.variant.id}&section_id=${this.dataset.section}`)
                .then((response) => response.text())
                .then((text) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(text, 'text/html');
                    const newFeatures = doc.querySelectorAll(`#ProductFeaturesBlock-${this.dataset.section} [data-update-on-variant-change]`);

                    if (newFeatures) {
                        this.querySelectorAll("[data-update-on-variant-change]").forEach((elm, index) => {
                            elm.innerHTML = newFeatures[index].innerHTML;
                        });
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        }
      }
    );
}